import React from "react";
import { Result } from "antd";
import styles from "./index.module.css";

const AppClosedPage = () => {
  return (
    <div className={styles.container}>
      <Result
        status="403"
        title="未知应用"
        subTitle="应用不存在或已关闭，请检查URL链接地址或者联系应用提供者"
        // extra={<Button type="primary">Back Home</Button>}
      />
    </div>
  );
};

export default AppClosedPage;
